// extracted by mini-css-extract-plugin
export var dividerContainer = "_8i-0";
export var line = "_8i-1";